import React, { useState, useRef, useEffect } from "react";
import "./Tooltip.scss";

const Tooltip = (props) => {
  let timeout;
  const [active, setActive] = useState(false);
  const tooltipRef = useRef();

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, props.delay || 200);
  };

  const hideTip = () => {
    clearInterval(timeout);
    if (tooltipRef.current) {
      tooltipRef.current.classList.add("exit");
    }

    setTimeout(() => {
      setActive(false);
    }, 300); // same duration as your exit animation
    
  };

  useEffect(() => {
    return () => clearInterval(timeout);
  }, []);

  useEffect(() => {
    return () => clearInterval(timeout);
  }, []);

  const isTouchDevice =
  "maxTouchPoints" in navigator && navigator.maxTouchPoints > 0 &&
  /(iPhone|iPad|Android|webOS|BlackBerry|Windows Phone|Opera Mini|IEMobile)/i.test(navigator.userAgent);
  
  return !isTouchDevice ? (
    <div
      className="Tooltip-Wrapper"
      // When to show the tooltip
      onMouseEnter={showTip}
      onMouseLeave={hideTip}
      donotcenter={props.donotcenter}>
      {/* Wrapping */}
      {props.children}
      {active && (
        <div
          ref={tooltipRef}
          className={`Tooltip-Tip ${props.direction || "top"}`}
          style={props.style} // Apply position here
        >
          {/* Content */}
          {props.content}
        </div>
      )}
    </div>
  ) : props.children;
};

export default Tooltip;
